import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button, FormInput, InputGroup, Table } from "elemental-react16"
import Price from "components/Price/Price"
import _ from "lodash"
import { Link } from "react-router-dom";
import LabelSale from "components/Product/LabelSale"
import { Label } from "semantic-ui-react"
import shop from "shop/shop"


export default class ProductTableReadOnly extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }

  render() {
    let { list, cart, products, onChange } = this.props
    let positions = list || products
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )
    return (
      <Table>
        <thead>
        <tr>
          <th>#</th>
          <th>{translate( "Artikel" )}</th>
          <th>{translate( "Lieferbar" )}</th>
          <th>{translate( "Preis" )}</th>
          <th>{translate( "Summe" )}</th>
          <th>{translate( "Stück" )}</th>
          <th className="tr">{translate( "Rabatt" )}</th>
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </Table>
    )
  }
}

const ProductRow = ( { product, index } ) => {
  const inCart = shop.cart.productsById.get( product.map_id )
  return (
    <tr>
      <td>
        {1 + index}
      </td>
      <td>
        <div>
          <div className="fl pr2 w-100 mw3">
            <Link to={`/product/${product.map_id}`}>
              <img
                className="db center"
                height="34"
                src={product.img_src_small}
                alt=""/>
            </Link>
          </div>
          <Link to={`/product/${product.map_id}`}>
            <div className={"b"}>{product.article_nr}</div>
            <div className="product-title">{product.title}</div>
            {/*<span className="unit_multi black-50">VE {product.unit_multi} {translate( "cart.piece" )}</span>*/}
          </Link>
        </div>
      </td>
      <td><span className="f6">{product.getNotice( "tiny" )}</span></td>
      <td>
        <div><Price>{product.price * product.unit_multi}</Price></div>
        {product.isSale &&
        <div><LabelSale price={product.originalPrice} percent={product.salePercent}/></div>}
        {product.extraValue.custom_discount && <Label color="green"><Price>{product.extraValue.custom_price}</Price></Label>}

      </td>
      <td>
        <div><Price>{product.price * product.count * product.unit_multi}</Price></div>
        {product.isSale &&
        <div><LabelSale price={product.originalPrice * product.count * product.unit_multi}
                        percent={product.salePercent}/></div>}
        {product.extras.custom_discount && <Label color="green"><Price>{product.extras.custom_price_sum}</Price></Label>}
      </td>
      <td className="tr">{product.count}</td>
      {shop.session.handId && <td className="tr">
        {inCart.extras.custom_discount && <div>{inCart.extras.custom_discount}%</div>}
        {/*<div>{inCart.discount_value}</div>*/}
        {/*<div>{inCart.discount_value_sum}</div>*/}

      </td>}
    </tr>
  )
}

ProductRow.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/Product/ProductTableReadOnly.js